// extracted by mini-css-extract-plugin
export default {"section":"wA-z","sectionTitle":"xA-z","fieldWrapper":"yA-z","formField":"zA-z","disabled":"AA-z","formLabel":"BA-z"};